import { SET_MANAGE_CASES, SET_ENTITY_LOOKUP, SET_CUSTOM_SEARCH } from "../actions/types";

const initialConfig = {
  workspaceid: "",
  entityid: "",
  mdmid: "",
  casesOptions: { limit: 10, page: 0, orderBy: "CREATED_AT", order: "desc", search: "", totalSkip: 0 },
  lookupOptions: { limit: 10, page: 0, orderBy: "MDM_ID", order: "asc" },
  customSearch: {},
};

//Handling User
export const casesReducer = (state = initialConfig, { type, payload }) => {
  switch (type) {
    case SET_MANAGE_CASES:
      return {
        ...state,
        workspaceid: payload.workspaceid ?? state.workspaceid,
        casesOptions: {
          ...state.casesOptions,
          ...payload.casesOptions,
        },
      };
    case SET_ENTITY_LOOKUP:
      return {
        ...state,
        workspaceid: payload.workspaceid ?? state.workspaceid,
        entityid: payload.entityid ?? state.entityid,
        mdmid: payload.mdmid ?? state.mdmid,
        lookupOptions: {
          ...state.lookupOptions,
          ...payload.lookupOptions,
        },
      };
    case SET_CUSTOM_SEARCH:
      return {
        ...state,
        ...(payload === undefined
          ? { customSearch: {} }
          : {
              customSearch: {
                ...state.customSearch,
                ...payload,
              },
            }),
      };
    default:
      return state;
  }
};
